<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :options.sync="optionsTable"
      :server-items-length="total"
      :loading="loading"
      show-expand
      :footer-props="{ itemsPerPageOptions: [10, 15, 20, 50, 100] }"
    >
      <template v-slot:top>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <template>
            <v-card class="pa-1">
              <v-card-title
                class="text-h5 text-center justify-center flex-column mb-5"
                >Удалить категорию?<br />
                <span class="accent--text">{{
                  itemCurrentName
                }}</span></v-card-title
              >

              <v-card-actions class="pb-4">
                <v-spacer></v-spacer>
                <v-btn color="accent" outlined @click="closeDelete"
                  >Отмена</v-btn
                >
                <v-btn color="accent" @click="deleteItemConfirm">OK</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </template>
      <template v-slot:item.invites="{ item }">
        {{ item.invites.length }}
      </template>
      <template v-slot:item.referrals="{ item }">
        {{ item.invited.length }}
      </template>
      <template v-slot:item.users="{ item }">
        {{ sortInvites(item.invites).length }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="py-4">
          <template v-if="item.invited.length">
            <b class="d-block mb-3">Рефералы</b>
            <v-simple-table
              class="mb-5"
              dense
              :height="item.invited.length > 8 ? 288 : 'auto'"
              fixed-header
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Программа</th>
                    <th class="text-left">Дата приглашения</th>
                    <th class="text-left">Статус</th>
                    <th class="text-left">Email</th>
                    <th class="text-left">Дата регистрации</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(invite, ind) in item.invited"
                    :key="`invite_${ind}`"
                  >
                    <td>{{ invite.invite.referral_program }}</td>
                    <td>
                      {{
                        moment(invite.invite.created_at).format(
                          "YYYY-MM-DD HH:mm"
                        )
                      }}
                    </td>
                    <td>{{ invite.invite.status }}</td>
                    <td>{{ invite.email }}</td>
                    <td>
                      {{ moment(invite.created_at).format("YYYY-MM-DD HH:mm") }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
          <template v-if="sortInvites(item.invites).length">
            <b class="d-block mb-3">Приглашения</b>
            <v-simple-table
              class="mb-5"
              dense
              fixed-header
              :height="sortInvites(item.invites).length > 8 ? 288 : 'auto'"
            >
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Программа</th>
                    <th class="text-left">Дата приглашения</th>
                    <th class="text-left">Статус</th>
                    <th class="text-left">Email</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(invite, ind) in sortInvites(item.invites)"
                    :key="`invite_${ind}`"
                  >
                    <td>{{ invite.referral_program }}</td>
                    <td>
                      {{ moment(invite.created_at).format("YYYY-MM-DD HH:mm") }}
                    </td>
                    <td>{{ invite.status }}</td>
                    <td>{{ invite.invite_email }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </template>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import api from "../../api";
import moment from "moment";

export default {
  name: "ReferralsTable",
  data() {
    return {
      dialogDelete: false,
      headers: [
        {
          text: "Приглашающий",
          align: "start",
          sortable: false,
          value: "email",
        },
        {
          text: "Рефералов",
          align: "center",
          sortable: false,
          value: "referrals",
        },
        {
          text: "Ожидают",
          align: "center",
          sortable: false,
          value: "users",
        },
        {
          text: "Приглашений",
          align: "center",
          sortable: false,
          value: "invites",
        },
        {
          text: "Подробнее",
          value: "data-table-expand",
          sortable: false,
          align: "center",
          width: 80,
        },
        // {
        //   text: "Действия",
        //   value: "actions",
        //   sortable: false,
        //   align: "end",
        // },
      ],
      items: [],
      editedIndex: -1,
      editedItem: null,
      optionsTable: {},
      total: 0,
      loading: true,
      errors: {},
      referrals: null,
      invites: null,
      updateInterval: null,
    };
  },

  computed: {
    itemCurrentName() {
      return this.editedIndex > -1 ? this.items[this.editedIndex].name : "";
    },
    sortInvites: () => {
      return (items) => {
        return items.filter((i) => i.status === "pending");
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    optionsTable: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },
  created() {
    this.updateInterval = setInterval(() => this.getItems(), 1000 * 60 * 5);
  },
  beforeDestroy() {
    this.updateInterval = clearInterval(this.updateInterval);
  },
  methods: {
    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      await this.removeItem(this.items[this.editedIndex].id);
      this.getItems();
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.createItem() };
        this.editedIndex = -1;
        this.errors = {};
        this.resetErrors(this.editedItem, "editedItem");
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.createItem() };
        this.editedIndex = -1;
      });
    },

    async getItems() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.optionsTable;
      try {
        const req = await api.referrals.referrals({
          sortBy: sortBy && sortBy.length > 0 ? sortBy[0] : null,
          sortDesc: sortDesc && sortDesc.length > 0 ? sortDesc[0] : null,
          page: page,
          itemsPerPage: itemsPerPage,
        });
        if (req.data) {
          this.items = req.data.items;
          this.total = req.data.total;
        }
        this.loading = false;
      } catch (e) {
        console.error(e);
        this.loading = false;
      }
    },

    async removeItem(id) {
      try {
        const nameDelete = this.items[this.editedIndex].name;
        await api.articles.deleteTag(id);
        this.$store.dispatch("showSnackbar", {
          msg: `Тег "${nameDelete}" удален`,
          color: "success",
          show: true,
        });
      } catch (e) {
        console.error(e);
        this.$store.dispatch("showSnackbar", {
          msg: "Ошибка удаления",
          color: "error",
          show: true,
        });
      }
    },
    moment(date) {
      return moment(date);
    },
  },
};
</script>

<style lang="scss" scoped></style>
